import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { closeAdditionalSale } from "@components/OrderTaking/Store/feature";
import { OrderSliceState } from "@components/OrderTaking/Store/feature/types";

import AdditionalSale from "./index";

export default function GlobalAdditionalSale(): JSX.Element | null {
    const dispatch = useDispatch();
    const isOpen = useSelector(
        (state: { orderSlice: OrderSliceState }) =>
            state.orderSlice.isAdditionalSaleOpen
    );
    if (!isOpen) return null;
    return (
        <AdditionalSale
            open
            onClose={() => dispatch(closeAdditionalSale())}
        />
    );
}
